import { Field, FormikProps } from "formik";
import React from "react";

import { ITestable } from "@/browser";
import { IBlurable, IChangeable } from "@/eworkitComponents";

import { clearApiError, isErrorVisible } from "./service";

export interface IWithFormikFieldProps {
  name: string;
}

export interface IInjectedFormikFieldProps extends IBlurable, IChangeable, ITestable {
  name?: string;
}

export function withFormikField<P extends IInjectedFormikFieldProps>(Component: React.ComponentType<P>) {
  type Props = P & IWithFormikFieldProps;

  return class FormikFieldWrapper extends React.PureComponent<Props> {
    form: FormikProps<any> | undefined;

    handleChange = (value: any) => {
      if (this.form) {
        clearApiError(this.form, this.props.name);

        this.form.setFieldValue(this.props.name, value, this.form.validateOnChange);

        if (this.props.onChange) {
          this.props.onChange(value);
        }
      }
    };

    handleBlur = () => {
      if (this.form) {
        this.form.setFieldTouched(this.props.name, true, this.form.validateOnBlur);

        if (this.props.onBlur) {
          this.props.onBlur();
        }
      }
    };

    render() {
      const { onBlur, onChange, name, ...rest } = this.props as any;
      return (
        <Field name={this.props.name}>
          {({ form }: { form: FormikProps<any> }) => {
            const errorVisible = isErrorVisible(form, name);

            this.form = form;

            return (
              <Component
                name={this.props.name}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                invalid={errorVisible}
                {...rest}
              />
            );
          }}
        </Field>
      );
    }
  };
}
